import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import retailService from '../services/retail/retailService';
import {selectIsAuthorized} from '../state/selectors/auth';
import {selectIsAppInitialized, selectIsRetail} from '../state/selectors/global';
import {selectIsRetailDevicesLoading} from '../state/selectors/retail';

const POLL_INTERVAL = 15_000;

const useRetail = () => {
    const isAuthorized = useSelector(selectIsAuthorized);
    const isAppInitialized = useSelector(selectIsAppInitialized);
    const isRetail = useSelector(selectIsRetail);
    const isRetailDevicesLoading = useSelector(selectIsRetailDevicesLoading);

    // Start polling process for get actual connected retail devices, if user authorized
    useEffect(() => {
        if (!isAuthorized || !isRetail || !isAppInitialized) return;

        let timeoutId;

        const poll = async () => {
            await retailService.getRetailData();
            timeoutId = setTimeout(poll, POLL_INTERVAL);
        };

        timeoutId = setTimeout(poll, POLL_INTERVAL);
        return () => clearTimeout(timeoutId);
    }, [isAuthorized, isRetail, isAppInitialized, isRetailDevicesLoading]);
};

export default useRetail;
